/* eslint-disable
    @trello/ban-identifiers,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS104: Avoid inline assignments
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import type { MonitorStatus } from './monitorStatus';
import { TrelloStorage, TrelloSessionStorage } from '@trello/storage';
import { monitorStatus } from './monitorStatus';
import { monitorEvents } from './monitorEvents';

interface DocumentHidden extends Document {
  mozHidden?: string;
  msHidden?: string;
  webkitHidden?: string;
}
type hiddenPropertyOptions = keyof typeof documentHidden;
let hiddenProperty: hiddenPropertyOptions;
let visibilityChange: string = '';

const documentHidden: DocumentHidden = document;

// From https://developer.mozilla.org/en-US/docs/Web/Guide/User_experience/Using_the_Page_Visibility_API
if (typeof documentHidden.hidden !== 'undefined') {
  // Opera 12.10 and Firefox 18 and later support
  hiddenProperty = 'hidden';
  visibilityChange = 'visibilitychange';
} else if (typeof documentHidden.mozHidden !== 'undefined') {
  hiddenProperty = 'mozHidden';
  visibilityChange = 'mozvisibilitychange';
} else if (typeof documentHidden.msHidden !== 'undefined') {
  hiddenProperty = 'msHidden';
  visibilityChange = 'msvisibilitychange';
} else if (typeof documentHidden.webkitHidden !== 'undefined') {
  hiddenProperty = 'webkitHidden';
  visibilityChange = 'webkitvisibilitychange';
}

let left;
let lastActivity = 0;
let status: MonitorStatus;

export const monitor = {
  init() {
    status =
      (left = TrelloSessionStorage.get('status')) != null ? left : 'active';
    setInterval(monitor.check, 10 * 1000);

    // Mark the user active if...
    // the window gets the focus
    // Note: since we can also detect when the window
    // loses the focus, we can make it so a window that
    // has no interaction but has the focus stays active
    // e.g. if someone is just staring at the board, but not
    // doing anything
    $(window).on('focus', () => monitor.addActivity());

    // the user presses a key or clicks something
    $(document).on('keydown mousedown', function () {
      monitor.addActivity();
    });

    if (visibilityChange != null) {
      $(document).on(visibilityChange, () => {
        return monitorEvents.trigger('visibilitychange');
      });
    }
  },

  getHidden() {
    if (hiddenProperty) {
      return documentHidden[hiddenProperty];
    }
    return false;
  },

  addActivity() {
    const now = new Date().getTime();
    lastActivity = now;

    TrelloStorage.set('lastActivity', lastActivity);

    monitor.setStatus('active');
  },

  check() {
    const delta =
      new Date().getTime() -
      Math.max(
        lastActivity,
        TrelloStorage.isEnabled()
          ? parseInt(TrelloStorage.get('lastActivity'), 10)
          : 0,
      );

    if (delta > 5 * 60 * 1000) {
      monitor.setStatus('idle');
    } // 5 minutes
  },

  setStatus(newStatus: MonitorStatus) {
    if (newStatus !== status) {
      status = newStatus;
      TrelloSessionStorage.set('status', status);
      monitorEvents.trigger('setStatus', status);
      monitorStatus.setValue(newStatus);
    }
  },

  getStatus() {
    return status;
  },
};
